import { MapPinIcon } from 'lucide-preact';

import { cn } from '@/lib/utils';

interface PausedBannerProps {
  currentSection?: string;
  nextHabitat?: string;
  mascotSrc: string;
  onResume: () => void;
  onSkipAhead?: () => void;
  className?: string;
}

const PausedBanner = ({ currentSection, nextHabitat, mascotSrc, onResume, onSkipAhead, className }: PausedBannerProps) => (
  <div className={cn('preflight relative h-[85px] shrink-0 grow-0 overflow-hidden bg-[#FFDF6C]', className)}>
    <img
      src={mascotSrc}
      alt="Zoolife mascot"
      className="preflight absolute left-[11px] top-0 h-[85px] w-[84px] object-contain"
    />

    <div className="preflight flex h-full">
      <div className="preflight w-[126px] shrink-0" />

      <div className="preflight relative min-w-0 flex-1">
        <p className="preflight preflight-p absolute top-[8px] text-[9px] font-bold uppercase leading-none text-[#458254]">
          TOUR-GUIDE
        </p>

        <div className="preflight absolute top-[20px] flex items-center gap-[3px]">
          <p className="preflight preflight-p text-[18px] font-bold leading-none text-[#265832]">
            {currentSection ?? 'Departure'}
          </p>
          <MapPinIcon className="preflight h-[17px] w-[17px] text-[#265832]" />
        </div>

        <p className="preflight preflight-p absolute left-[289px] top-[8px] text-[9px] font-bold uppercase leading-none text-[#458254]">
          NEXT HABITAT
        </p>

        <p className="preflight preflight-p absolute left-[289px] top-[20px] text-[18px] font-bold leading-none text-[#265832]">
          {nextHabitat ?? '\u2014'}
        </p>

        <div className="preflight absolute top-[45px] flex h-[28px] items-center">
          <div className="preflight h-[24px] w-[24px] shrink-0 rounded-full border-[3px] border-[#458254] bg-white" />
          <div className="preflight h-[8px] w-[253px] shrink-0 bg-[#458254]" />
          <div className="preflight h-[24px] w-[24px] shrink-0 rounded-full bg-[#458254]" />
          <div
            className="preflight h-[8px] w-[225px] shrink-0"
            style={{ background: 'linear-gradient(to right, #458254, transparent)' }}
          />
        </div>
      </div>

      <div className="preflight flex shrink-0 items-center gap-[7px] pr-[14px]">
        {nextHabitat && (
          <button
            type="button"
            onClick={() => onSkipAhead?.()}
            className="preflight preflight-button flex h-[42px] w-[244px] items-center justify-center whitespace-nowrap rounded-[100px] border-2 border-[#265832] text-[16px] font-bold text-[#265832]"
          >
            Skip Ahead to Next Habitat
          </button>
        )}
        <button
          type="button"
          onClick={onResume}
          className="preflight preflight-button flex h-[42px] items-center justify-center whitespace-nowrap rounded-[100px] bg-[#458254] px-[20px] text-[16px] font-bold text-white"
        >
          Explore with Guide
        </button>
      </div>
    </div>
  </div>
);

export default PausedBanner;
